import { Component } from '@angular/core';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
/** Cart component*/
export class CartComponent {
  /** Cart ctor */
  constructor() {
    
  }
  navStatus = "";

  CartPopup() {
    if (this.navStatus == "") {
      this.navStatus = "open";
    } else {
      this.navStatus = "";
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/cart/cart.component.ts